// extracted by mini-css-extract-plugin
export default {"chooseImage":"Choose_chooseImage__SD4KS","box":"Choose_box__izeUx"};